import faker from 'faker';

export default Array(10)
  .fill(0)
  .map((_, index) => ({
    id: index,
    contratoId: faker.random.number({ min: 10, max: 100 }),
    numero: faker.random.number({ min: 1000, max: 5000 }),
    ordem: index,
    dataTermino: faker.date.future(10).toLocaleString(),
    tipoAditivo: faker.lorem.words(10),
    valor: faker.finance.amount()
  }));
